// src\themes\mad\elements\Header\Header.tsx
import HeaderWrapper from './HeaderWrapper';

import {
  getSidebarMainMenu,
  getSidebarSecondaryMenu,
} from '@/core/lib/api/main/menu-api';
import { getSettings } from '@/core/lib/api/main/setting';
import { MenuResponseData } from '@/core/types/menuApi';
import HeaderNavMenu from './HeaderNavMenu';
import HeaderNavToggle from './HeaderNavToggle';
import Sidebar from './Sidebar';
import HeaderLogo from './HeaderLogo';

export default async function Header() {
  const setting = await getSettings();
  const menuItemsData: MenuResponseData = await getSidebarMainMenu();
  const introductionSidebarData: MenuResponseData = await getSidebarSecondaryMenu();

  return (
    <>
      <HeaderWrapper>
        <header className="h-18 print:hidden flex items-center justify-between px-4 py-4 sm:px-6 lg:px-12 transition-colors duration-300 border-b border-primary-100">
          <div className="flex items-center gap-3 w-10/12 lg:w-1/12">
            <HeaderNavToggle />
          </div>
          <HeaderNavMenu />
          <HeaderLogo setting={setting} />
        </header>
      </HeaderWrapper>

      <Sidebar
        setting={setting}
        mainItems={menuItemsData?.items || []}
        mainDescription={menuItemsData?.description || ''}
        introItems={introductionSidebarData?.items || []}
        introDescription={introductionSidebarData?.description || ''}
      />
    </>
  );
}
